import {
  GoabBadge,
  GoabPageBlock,
  GoabSpacer,
  GoabText,
  GoabLink,
} from "@abgov/react-components";
import { Link } from "react-router-dom";
import {
  domainKey,
  refCategories,
  getBadgeType,
  getBadgeEmphasis,
} from "../../../MPP-Common-SPA/utils/globalUtility";
import DisplayContent from "../../../MPP-Common-SPA/components/DynamicForm/Forms/DisplayContent";
import "./StepHeader.css";
import { InternalApplicationStatuses } from "../../../MPP-Common-SPA/common/constants/statuses";
import { getProgramEventNameByCode } from "../../../MPP-Common-SPA/utils/getProgramEventNameByCode";

export const StepHeader = (input) => {
  const {
    currentStep,
    getResourceValue,
    getRefData,
    applicationType,
    internalStatus,
    onPrevious,
    numberOfSteps,
    inReviewMode,
    userApplicationData,
    programEvents,
    user,
    isEventsEnabled,
  } = input ?? {};

  const { stepNumber, renderer: { props } = {} } = currentStep ?? {};

  const {
    showBackButton,
    showStepCounter,
    showFinalStepCounter,
    showBadge,
    showEventTag = true,
  } = props ?? {};

  const displayBadge =
    (showStepCounter || showFinalStepCounter || showBadge) && isEventsEnabled;

  const appStatusesRefData = getRefData({
    category: refCategories.APP_STATUS,
    domainKey,
  });
  const applicationStatus = appStatusesRefData?.find(
    (e) => e.code === "" + internalStatus,
  )?.description;

  const applicationTypeName = getProgramEventNameByCode(
    programEvents,
    applicationType,
  );
  const displayEventTag =
    showEventTag &&
    (applicationTypeName ??
      applicationType ??
      userApplicationData?.uniqueApplicationCode);

  return (
    <GoabPageBlock width="704px" data-testId="stepRenderer">
      {showBackButton && !inReviewMode && !showStepCounter && (
        <>
          <GoabSpacer vSpacing="2xl" />
          <Link to="" onClick={() => onPrevious({}, [], {}, getRefData)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
              viewBox="5 -5 24 24"
              stroke="currentColor"
            >
              <path d="M15 19l-7-7 7-7" />
            </svg>
            <span className="body-m">
              {getResourceValue({
                key: "RESOURCES@global.button.back",
              })}
            </span>
          </Link>
        </>
      )}
      {(inReviewMode ||
        internalStatus === InternalApplicationStatuses.Withdrawn) &&
        internalStatus > InternalApplicationStatuses.Draft &&
        !user.isProxyUser && (
          <>
            <GoabSpacer vSpacing="2xl" />
            <GoabLink color="dark" leadingIcon="chevron-back">
              <a href="/applications">
                {getResourceValue({
                  key: "RESOURCES@global.button.backToMyApplications",
                })}
              </a>
            </GoabLink>
            <GoabSpacer vSpacing="xs" />
          </>
        )}

      {displayBadge && (
        <>
          {internalStatus && (
            <GoabBadge
              type={getBadgeType(internalStatus)}
              emphasis={getBadgeEmphasis(internalStatus)}
              mt="l"
              content={getResourceValue({
                key: "RESOURCES@global.applicationStatus",
                params: {
                  applicationStatus: applicationStatus ?? internalStatus,
                },
              })}
            ></GoabBadge>
          )}
          {
            <>
              {(displayEventTag && <GoabSpacer vSpacing="2xl" />) || (
                <GoabSpacer vSpacing="xl" />
              )}
              <div className="space-between">
                {displayEventTag && (
                  <div>
                    <span className="appType">
                      {applicationTypeName ?? applicationType}
                    </span>
                  </div>
                )}

                <div>
                  {userApplicationData?.uniqueApplicationCode && (
                    <DisplayContent
                      content={getResourceValue({
                        key: "RESOURCES@global.applicationCode",
                        params: {
                          uniqueApplicationCode:
                            userApplicationData.uniqueApplicationCode,
                        },
                      })}
                    />
                  )}
                </div>
              </div>
            </>
          }
        </>
      )}

      <GoabSpacer vSpacing="l" />
      {showStepCounter && (
        <>
          <p
            className="body-l"
            style={{ color: "var(--goa-color-text-secondary)" }}
          >{`Step ${stepNumber} of ${numberOfSteps}`}</p>
          <GoabSpacer vSpacing="xs" />
        </>
      )}
      {!showStepCounter && showFinalStepCounter && (
        <>
          <p
            className="body-l"
            style={{ color: "var(--goa-color-text-secondary)" }}
          >
            Final Step
          </p>
        </>
      )}
      {currentStep.title && (
        <>
          <GoabSpacer vSpacing="m" />
          <h1>{getResourceValue({ key: currentStep.title })}</h1>
        </>
      )}
      {currentStep.subTitle && (
        <>
          {/* Only add spacing if title is shown */}
          {currentStep.title && <GoabSpacer vSpacing="m" />}
          <h2>{getResourceValue({ key: currentStep.subTitle })}</h2>
        </>
      )}
      {currentStep.description && (
        <>
          <GoabSpacer vSpacing="xs" />
          <p
            className="body-l"
            dangerouslySetInnerHTML={{
              __html: getResourceValue({ key: currentStep.description }),
            }}
          ></p>
        </>
      )}
    </GoabPageBlock>
  );
};
